import React, { useContext, useState } from "react";
import "./style.scss";
import Button from "../../common/Button";
import { message } from "antd";
import { usePayOrderFromBatch } from "../../hooks/useUserWallet";
import { UserWalletContext } from "../../context/userWalletContext";

const PayFromWallet = ({ batch, markpaymentSuccessful }) => {
  const { walletDetails, setSelectedOrderForPayment } =
    useContext(UserWalletContext);
  console.log(batch);
  const onSuccess = (res) => {
    console.log(res);
    if (res.status === 200) {
      message.success("Payment Successful");
      markpaymentSuccessful();
      setSelectedOrderForPayment();
    }
  };

  const onError = (err) => {
    message.error(err);
  };

  const { mutate: payOrder } = usePayOrderFromBatch(onSuccess, onError);

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      batchId: batch?.batchId,
    };

    payOrder(payload);
  };

  const getWalletSummary = () => {
    return (
      <div className="wallet_summary">
        <div className="amount_field">
          <h2 className="title">
            Order Amount <span>${batch?.orderAmount}</span>
          </h2>
        </div>
      </div>
    );
  };

  return (
    <div className="pay_from_wallet">
      <div className="wallet_header">
        <h2 className="wallet_title">Pay Now</h2>
        <h3 className="amount">
          Current Wallet Amount{" "}
          <span>${walletDetails?.availableBalance?.unitAmount}</span>
        </h3>
      </div>
      {getWalletSummary()}
      <div className="action_btn">
        <Button
          width="100%"
          height="39px"
          text={"Pay Now"}
          handleClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default PayFromWallet;
